import { motion } from "framer-motion";

export default function Policies() {
  return (
    <motion.main
      data-testid="policies-page"
      className="pt-14"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="mx-auto max-w-xl px-6 py-12">
        <section className="mb-12">
          <h2 className="mb-4 text-xl font-bold tracking-tight text-neutral-900">REFUNDS</h2>
          <p className="text-sm leading-relaxed text-neutral-600">
            We kindly request that you review your order before confirming your purchase. It is
            important to note that all sales are final, we do not offer refunds or exchanges.
          </p>
        </section>
        <section>
          <h2 className="mb-4 text-xl font-bold tracking-tight text-neutral-900">SHIPPING</h2>
          <p className="text-sm leading-relaxed text-neutral-600">
            Please allow 2-3 days for shipping. Shipped via USPS. Tracking numbers are updated and
            sent via email.
          </p>
        </section>
      </div>
    </motion.main>
  );
}
